export const statusList = [
  { id: "active", name: "Active" },
  { id: "being_repaired", name: "BeingRepaired" },
  { id: "archive", name: "Archive" },
];
